module.exports = __webpack_public_path__ + "img/apidays-ppt-1.35c8efaf.png";